import { atom, selector } from 'recoil';
import { Sites, GetDetailSiteDtoRx } from '@/sdk/data-contracts';

export const siteListRecoil = atom<Sites[]>({
  key: 'siteListRecoil',
  default: [],
});

export const siteModifyRecoil = atom<GetDetailSiteDtoRx | null>({
  key: 'siteModifyRecoil',
  default: null,
});

// export const siteModifyNumRecoil = atom<number | null>({
//   key: 'siteModifyNumRecoil',
//   default: null,
// });

// export const siteModifyRecoil = selector<SiteDto | null>({
//   key: 'siteModifyRecoil',
//   get: ({ get }) => {
//     const list = get(siteListRecoil);
//     const modifyNum = get(siteModifyNumRecoil);
//     if (list && modifyNum !== null) {
//       return list.find((item) => item.id === modifyNum) || null;
//     } else {
//       return null;
//     }
//   },
// });
